import api, { methods } from "@api";
import AlertMessage from "@components/alert-message";
import Button from "@components/button";
import { useAuth } from "@provider/context-auth";
import { toast } from "@provider/toast";
import { useMutation } from "@tanstack/react-query";
import type { AccountUpdateInput } from "@type/account";
import { getUpdateProfileData } from "@utils";
import { View } from "dripsy";
import * as React from "react";
import type { FooterStoryblok } from "@type/storyblock-types";
import { useStoryBlokStory } from "@provider/storyblok-provider";

export default function ReceiveNewsletter() {
  const content = useStoryBlokStory<FooterStoryblok>("footer");

  const { profile, refetch } = useAuth();
  const initialChecked = profile?.receive_newsletter === 1;
  const [receiveNewsletter, setReceiveNewsletter] = React.useState(initialChecked);

  // update if profile changes
  React.useEffect(() => {
    setReceiveNewsletter(initialChecked);
  }, [initialChecked]);

  const { mutate: updateAccount } = useMutation({
    mutationFn: (data: AccountUpdateInput) =>
      api<{ status: string }>({
        path: "/account/klant/update",
        method: methods.PATCH,
        body: { data },
      }),
    onSuccess: (res) => {
      refetch();
    },
    onError: (error) => {
      console.log("error", error);
      setReceiveNewsletter(initialChecked);
    },
  });

  const onChange = (v: boolean) => {
    setReceiveNewsletter(v);
    updateAccount(
      getUpdateProfileData({
        contentType: "newsletter",
        mailType: "newsletter",
        profile: {
          ...profile!,
          receive_newsletter: v ? 1 : 0,
        },
      })
    );
  };

  if (initialChecked === true) {
    return <AlertMessage isSuccess>{content.newsletter_success_message}</AlertMessage>;
  }

  return (
    <View style={{ maxWidth: 500 }}>
      <Button
        isLoading={initialChecked !== receiveNewsletter}
        onPress={() => {
          onChange(!receiveNewsletter);
          toast?.show(content.newsletter_success_message);
        }}
      >
        {content.newsletter_message}
      </Button>
    </View>
  );
}
